import { initialChatState, type ChatState } from "@/hooks/useChat"

/**
 * Module-level Archie session so Turbo shell remounts (turbo:load /
 * turbo:before-cache) do not wipe an in-progress conversation. Hard refresh
 * still starts clean because the module reloads.
 */
export interface ArchieSessionSnapshot {
  chatId: number | null
  locale: string
  open: boolean
  state: ChatState
}

const session: ArchieSessionSnapshot = {
  chatId: null,
  locale: "en",
  open: false,
  state: { ...initialChatState },
}

export function readArchieSession(): ArchieSessionSnapshot {
  return {
    chatId: session.chatId,
    locale: session.locale,
    open: session.open,
    state: {
      messages: session.state.messages,
      toolCalls: session.state.toolCalls,
      isStreaming: session.state.isStreaming,
      error: session.state.error,
    },
  }
}

export function writeArchieSession(partial: Partial<ArchieSessionSnapshot>): void {
  if (partial.chatId !== undefined) session.chatId = partial.chatId
  if (partial.locale !== undefined) session.locale = partial.locale
  if (partial.open !== undefined) session.open = partial.open
  if (partial.state !== undefined) {
    session.state = {
      messages: partial.state.messages,
      toolCalls: partial.state.toolCalls,
      isStreaming: partial.state.isStreaming,
      error: partial.state.error,
    }
  }
}

/** Test-only reset. */
export function resetArchieSession(): void {
  session.chatId = null
  session.locale = "en"
  session.open = false
  session.state = { ...initialChatState, messages: [], toolCalls: [] }
}
